import { __assign, __rest } from "tslib";
import * as React from 'react';
import { MenuItem as BbUiMenuItem } from '../../MenuItem';
import { useStyles } from './Listbox.Option.styles';
export var ListboxOption = React.forwardRef(function (props, ref) {
    var children = props.children, selected = props.selected, isMulti = props.isMulti, other = __rest(props, ["children", "selected", "isMulti"]);
    var classes = useStyles(props);
    return (React.createElement(BbUiMenuItem, __assign({ ref: ref, button: true, role: "option", classes: {
            root: classes.menuItem,
            selected: isMulti ? classes.multiSelected : classes.selected,
        }, "aria-selected": selected, selected: selected }, other), children));
});
export default ListboxOption;
//# sourceMappingURL=Listbox.Option.js.map